import AtlStorage from 'api/AtlStorage';

export const paymentDetails = new AtlStorage('btf.purchase.paymentdetails', window.sessionStorage);
export const paypalDetails = new AtlStorage('btf.purchase.paypalDetails', window.sessionStorage);
export const checkoutMode = new AtlStorage('btf.checkout.mode', window.sessionStorage, '');
export const sessionId = new AtlStorage(
  'btf.purchase.paymentdetails.sessionId',
  window.sessionStorage,
);
